// Status transition rules based on the provided logic
export const STATUS_TRANSITIONS = {
  reserved: {
    owner: 'canceled',
    booker: 'canceled'
  },
  confirmed: {
    owner: 'canceled',
    auto: 'canceled'
  },
  checkin: {
    auto: 'finished'
  }
};

// All possible status values
export const RESERVATION_STATUSES = [
  'reserved',
  'confirmed', 
  'checkin',
  'canceled',
  'finished'
];

// Status display names
export const STATUS_DISPLAY_NAMES = {
  reserved: 'Reserved',
  confirmed: 'Confirmed',
  checkin: 'Checked In',
  canceled: 'Canceled',
  finished: 'Completed'
};

// Status colors for UI
export const STATUS_COLORS = {
  reserved: 'bg-yellow-100 text-yellow-800',
  confirmed: 'bg-blue-100 text-blue-800',
  checkin: 'bg-green-100 text-green-800',
  canceled: 'bg-red-100 text-red-800',
  finished: 'bg-gray-100 text-gray-800'
};

// Status icons for UI
export const STATUS_ICONS = {
  reserved: 'ExclamationTriangleIcon',
  confirmed: 'CheckCircleIcon',
  checkin: 'CheckCircleIcon',
  canceled: 'XCircleIcon',
  finished: 'CheckCircleIcon'
};

// Get status display name
export const getStatusDisplayName = (status) => {
  return STATUS_DISPLAY_NAMES[status?.toLowerCase()] || status || 'Unknown';
};

// Get status color
export const getStatusColor = (status) => {
  return STATUS_COLORS[status?.toLowerCase()] || 'bg-gray-100 text-gray-800';
};

// Get status icon name
export const getStatusIconName = (status) => {
  return STATUS_ICONS[status?.toLowerCase()] || 'ExclamationTriangleIcon';
};

// Check if status transition is valid
export const isValidStatusTransition = (prevState, reason, newState) => {
  const transitions = STATUS_TRANSITIONS[prevState];
  return transitions && transitions[reason] === newState;
};

// Get possible next states for a given current state
export const getPossibleNextStates = (currentState) => {
  const transitions = STATUS_TRANSITIONS[currentState];
  return transitions ? Object.values(transitions) : [];
};

// Get explanation for status transition
export const getStatusTransitionExplanation = (prevState, reason, newState) => {
  const explanations = {
    'reserved-owner-canceled': 'The owner manually canceled a reserved booking.',
    'reserved-booker-canceled': 'The user who booked it canceled the reservation.',
    'confirmed-owner-canceled': 'The owner canceled after the booking was confirmed.',
    'confirmed-auto-canceled': 'System auto-canceled after expiry/no action.',
    'checkin-auto-finished': 'System automatically marked booking as completed.'
  };
  
  const key = `${prevState}-${reason}-${newState}`;
  return explanations[key] || 'Status changed';
}; 